import { useMagicSourceStore } from "@/src/store/slices/magicSource.slice"
import { useBulkUpload } from "@/src/services/bulkUploads"
import { useEffect } from "react"

// Hook for accessing magic source status
export const useMagicSourceStatus = () => {
    const pollStatus = useMagicSourceStore((state) => state.pollStatus)
    const bulkUploadResult = useMagicSourceStore((state) => state.bulkUploadResult)

    return { pollStatus, bulkUploadResult }
}

// Initialization hook for setting up magic source functionality
export const useMagicSourceInitialization = () => {
    const setBulkResult = useMagicSourceStore((state) => state.setBulkResult)

    const { startBulkUpload } = useBulkUpload((data) => {
        setBulkResult(data)
        return Promise.resolve()
    }, true)

    // Store the bulk upload function in the store for pollStatus to use
    useEffect(() => {
        useMagicSourceStore.setState({
            pollStatus: (bulkJobId: string) => {
                if (!bulkJobId) return
                startBulkUpload({ data: { data: { id: bulkJobId } } })
            },
        })
    }, [startBulkUpload])
}
